/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PassedInputs */



/**
* | output |
* | --- |
* | "Passed" |
*
* @param {PassedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const passed = /** @type {((inputs?: PassedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PassedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réussi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestanden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прошедший")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("通过")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合格した")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तीर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovado")
	return /** @type {LocalizedString} */ ("Passed")
});